<p class="text-center {{data.status === true ? 'custom-title-message-blue' : 'custom-title-message-danger' }}">{{data.message}}</p>
<p class="text-center custom-show-name">{{data.infoSchoolYear.fullname | substring: 20}} ({{data.infoSchoolYear.code | substring: 20}})</p>
<br>
<p class="custom-message text-center">Bạn có chắc muốn thực hiện thay đổi này không ?</p>
<p class="text-center">
    <button mat-dialog-close class="btn btn-close-custom">HỦY</button>&nbsp;&nbsp;
    <button class="btn btn-add" (click)="confirmStatus()">XÁC NHẬN</button>
</p>
